import { DOCUMENT } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
  type SupportedLanguage,
} from './i18n/language';

const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  da: 'Dansk',
};

@Component({
  imports: [RouterOutlet, TranslatePipe],
  selector: 'app-root',
  styleUrl: './app.css',
  templateUrl: './app.html',
})
export class App {
  private readonly translate = inject(TranslateService);
  private readonly document = inject(DOCUMENT);

  protected readonly title = signal('Client.KeyboxPortal');
  protected readonly year = new Date().getFullYear();
  protected readonly languages = SUPPORTED_LANGUAGES.map((code) => ({
    code,
    label: LANGUAGE_LABELS[code],
  }));
  protected readonly currentLanguage = signal<SupportedLanguage>(
    (this.translate.getCurrentLang() as SupportedLanguage | null) ?? DEFAULT_LANGUAGE,
  );

  constructor() {
    this.document.documentElement.lang = this.currentLanguage();
  }

  protected changeLanguage(language: string): void {
    const next = language as SupportedLanguage;
    this.translate.use(next);
    this.currentLanguage.set(next);
    this.document.documentElement.lang = next;
    localStorage.setItem(LANGUAGE_STORAGE_KEY, next);
  }
}
